import React from "react";
import Layout from "@/components/Layout";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const ShippingPolicy = () => {
  return (
    <>
      <SEO title="Shipping Policy - Send a Sloth" />
      <Layout>
        <h1 className="text-center text-[#294870] text-4xl lg:text-5xl font-bold">
          Shipping Policy
        </h1>
        <div className="flex items-center justify-center py-8 w-full h-auto">
          <div className="max-w-3xl text-lg text-gray-700 leading-relaxed space-y-6">
            <h2 className="text-2xl font-semibold text-[#294870]">
              Shipping Information
            </h2>
            <p>
              We offer a variety of shipping options to suit your needs. Please
              note that shipping times and costs may vary depending on your
              location and the shipping method chosen.
            </p>

            <h3 className="text-xl font-semibold text-[#294870]">
              Shipping Methods
            </h3>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>Standard Shipping:</strong> Free for orders over £30.
                Estimated delivery within <strong>1-2 business days</strong>.
              </li>
              <li>
                <strong>Express Shipping:</strong> Available at an additional
                cost. Estimated delivery within <strong>1 business day</strong>.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-[#294870]">
              Order Processing
            </h3>
            <p>
              Orders are typically processed within{" "}
              <strong>2 business days</strong>. You will receive an email
              confirmation once your order has been shipped, along with a
              tracking number.
            </p>

            <h3 className="text-xl font-semibold text-[#294870]">
              International Shipping
            </h3>
            <p>
              We currently ship within the UK only. If you are outside of the
              UK, please contact us for a shipping quote.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">Returns</h2>
            <p>
              We offer a <strong>14-day return policy</strong> for most items.
              Please refer to our{" "}
              <a href="/refunds" className="text-blue-500 underline">
                Refund Policy
              </a>{" "}
              for more information.
            </p>

            <h3 className="text-xl font-semibold text-[#294870]">Contact Us</h3>
            <p>
              If you have any questions about our shipping policy, please
              contact us at:
            </p>
            <address className="not-italic space-y-1">
              <p>Send a Sloth</p>
              <p>Mango Drum Ltd.</p>
              <p>86-90 Paul Street, London, England, EC2A 4NE</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:info@sloths.co.uk"
                  className="text-blue-500 underline"
                >
                  info@sloths.co.uk
                </a>{" "}
                or{" "}
                <a
                  href="mailto:amazon@sloths.co.uk"
                  className="text-blue-500 underline"
                >
                  amazon@sloths.co.uk
                </a>
              </p>
            </address>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default ShippingPolicy;
